import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetStatistics = () => api.get(apiUrl.stats);
